export const ProblemModel = {
    Active: "Active",
    Inactive: "Inactive",
    All: "All",
}


// WEBPACK FOOTER //
// ./src/Models/ProblemModel.js